import React from 'react';
import { Group, Skeleton, Box } from '@landr/maestro';

export const CollectionsListItemSkeleton = (): JSX.Element => (
    <Group
        alignItems="center"
        gutter="sm"
        width="100%"
        px="lg"
        py="sm"
        data-testid="collections-list-item-skeleton-wrapper"
    >
        <Group.Item>
            <Skeleton width="36px" height="36px" />
        </Group.Item>
        <Group.Item width="100%">
            <Box display="flex" flexDirection="column">
                <Skeleton mb="xxs" height="12px" width="50%" />
                <Skeleton height="12px" width="25%" />
            </Box>
        </Group.Item>
    </Group>
);
